import { render, staticRenderFns } from "./SGPConfirmacaoDelecaoComponent.vue?vue&type=template&id=77bdfd9c"
import script from "./SGPConfirmacaoDelecaoComponent.vue?vue&type=script&lang=js"
export * from "./SGPConfirmacaoDelecaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports